export default "__VITE_ASSET__CTE4N4$L__"